import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import {
  Button,
  Card,
  Col,
  Form,
  Layout,
  Row,
  Spin,
  Tooltip,
  Switch,
} from "antd";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PaymentComponent from "../../components/payment";
import { useAppDispatch, useAppSelector } from "../../hooks/reduxHooks";
import Header from "../../layout/protectedLayout/protectedLayoutStore/headers/pageHeader";
import {
  createPaymentIntentApi,
  getSubscriptionPlansApi,
  processPaymentApi,
} from "../../services/payment.service";
import calendar from "./../../assets/images/checkout.png";
import serum from "./../../assets/images/serum.png";
import support from "./../../assets/images/support.png";
import divider from "./../../assets/images/payment/divider.png";
import iconFull from "./../../assets/images/icons/iconFull.png";
// get icon
import Icon1 from "./../../assets/images/thank-you/icon1.png";
import Icon2 from "./../../assets/images/thank-you/icon2.png";
import Icon3 from "./../../assets/images/thank-you/icon3.png";
import Icon4 from "./../../assets/images/thank-you/icon4.png";
import Icon5 from "./../../assets/images/thank-you/icon5.png";
import Icon6 from "./../../assets/images/thank-you/icon6.png";
import Icon7 from "./../../assets/images/thank-you/icon7.png";
import Icon8 from "./../../assets/images/thank-you/icon8.png";
import Icon9 from "./../../assets/images/thank-you/icon9.png";
import Icon10 from "./../../assets/images/thank-you/icon10.png";
import Icon11 from "./../../assets/images/thank-you/icon11.png";
import {
  setUserId,
  setFeedbackSurveyId,
} from "../../store/slice/feedback.slice";
import MostPopular from "./mostPopularicon";
const PUBLIC_KEY: any = process.env.REACT_APP_STRIPE_PUBLIC_KEY;

const stripePromise = loadStripe(PUBLIC_KEY);
const list = [
  {
    title: "1x Human Expert Guidance",
    tooltips: "You’ll get one routine checkup per 3 months",
    image: Icon1,
  },
  {
    title: "How to use products",
    tooltips: "Know exactly what to keep, swap, and stop using",

    image: Icon4,
  },
  {
    title: "Where to buy products",
    tooltips:
      "Some links have discount code without affiliate links. Discounts are just for your benefit.",
    image: Icon9,
  },
  {
    title: "AI Ingredient Checker",
    tooltips: "Find what’s in your product in the most simple language",
    image: Icon11,
  },
  {
    title: "Daily Step-by-Step Routine",
    tooltips:
      "No more confusion of what to use today. Get daily skincare steps email reminder.",
    image: Icon2,
  },
  {
    title: "Revise Expert Routine",
    tooltips:
      "You can request to change your routine if you are not happy with it. We make sure you are satisfied.",
    image: Icon8,
  },
  {
    title: "Targeted Skin Concern Advice",
    tooltips: "Solutions with practical advice just for your skin issues",
    image: Icon10,
  },
  // {
  //   title: "Personal AI Skin Coach",
  //   tooltips:
  //     "Ask any skin questions you have 24x7 with your personal skin coach",
  //   image: Icon7,
  // },
  {
    title: "Smart Skincare Tracker",
    tooltips:
      "Save your skin from using expired products. Track products smartly.",
    image: Icon3,
  },
  {
    title: "Skin Progress Journal",
    tooltips: "See and compare photos of how your skin is improving.",
    image: Icon6,
  },
  {
    title: "Passive Cash Income",
    tooltips:
      "Earn 5% recurring referral income. You are not only saving here, but also earning passively.",
    image: Icon5,
  },
];

const peaceOfMindList = [
  {
    title: "30 days money back guarantee",
    icon: calendar,
  },
  {
    title: "Priority support from human expert",
    icon: support,
  },
  {
    title: "All the research done for you",
    icon: serum,
  },
];

const PaymentHistory = () => {
  const [clientSecret, setClientSecret] = useState<any>("");
  const [pricing, setPricing] = useState<any>();
  const [loadingPayment, setLoadingPayment] = useState(false);
  const [surveyId, setSurveyId] = useState<any>();
  const [data, setData] = useState<any>();
  const [isZeroAmount, setIsZeroAmount] = useState(false);
  const [showStripePayment, setShowStripePayment] = useState(true);
  const [loadingPaymentConfirmation, setLoadingPaymentConfirmation] =
    useState<boolean>(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { r, winner_token } = Object.fromEntries(
    new URLSearchParams(location.search)
  );
  const dispatch = useAppDispatch();
  const state = useAppSelector((state) => state);
  const { userData }: { userData?: any } = state.profile;
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [subscriptionPlans, setSubscriptionPlans] = useState<{
    quarterly: any;
    yearly: any;
  }>({
    quarterly: null,
    yearly: null,
  });
  const [selectedPlan, setSelectedPlan] = useState<any>();

  useEffect(() => {
    createPaymentIntent();
    fetchSubscriptionPlansApi();
  }, []);

  const fetchSubscriptionPlansApi = () => {
    dispatch(
      getSubscriptionPlansApi({
        finalCallback: () => { },
        successCallback: (data?: any) => {

          const plans: any = {};

          data?.forEach((plan: any) => {
            const key = plan.product_name?.toLowerCase();

            plans[key] = {
              ...plan,
              formatted_amount: formatted(plan.amount),
              interval_name: plan.interval_name,
              plan_name: plan.product_name,
              plan_interval: plan.interval,
              plan_intervalcount: plan.interval_count,
            };
          });

          setSubscriptionPlans(plans);
        },
        unAunthenticatedCallback: () => { },
      })
    );
  };

  const createPaymentIntent = () => {
    // setLoading(true);
    dispatch(
      createPaymentIntentApi({
        data: {
          email: localStorage.getItem("user_email"),
          survey_id: localStorage.getItem("survey_id"),
          // referral_code: r,
          // winner_token: winner_token,
        },

        finalCallback: () => {
          setLoading(false);
        },
        successCallback: (data?: any) => {
          setPricing(data?.amount);
          setClientSecret(data?.client_secret);
          setShowStripePayment(true);
          setData(data);

          if (data?.client_secret === null) {
            setLoadingPayment(false);
            setIsZeroAmount(true);
          }
        },
      })
    );
  };

  useEffect(() => {
    setSelectedPlan(
      checked ? subscriptionPlans?.yearly : subscriptionPlans?.quarterly
    );
  }, [subscriptionPlans]);

  const appearance = {
    theme: "stripe",
  };

  const options: any = {
    clientSecret: clientSecret,
    appearance,
  };

  const paymentConfirmation = (e: any, intent?: any) => {
    e.preventDefault();
    setLoadingPaymentConfirmation(true);
    dispatch(
      processPaymentApi({
        data: {
          survey_id: localStorage.getItem("survey_id"),
          payment_method: intent?.payment_method,
          subscription_plan_id: selectedPlan?.id,
          subscription_plan_amount: selectedPlan?.amount,
          email: localStorage.getItem("user_email"),
          name: localStorage.getItem("user_name"),
        },
        finalCallback: () => {
          setLoadingPaymentConfirmation(false);
        },
        successCallback: (response?: any) => {
          localStorage.setItem("alrounderToken", response?.data?.token);
          dispatch(setUserId(response?.data?.user_id));
          dispatch(setFeedbackSurveyId(response?.data?.id));
          navigate("/thank-you");
        },
      })
    );
  };
  const defaultData = {
    initial_amount: 35,
    discount_amount: 0,
    total_amount: 35,
  };
  const [checked, setChecked] = useState<boolean>(false);
  const onChange = (value: boolean) => {
    setChecked(value);
    setButtonPrice(null);
  };

  useEffect(() => {
    setSelectedPlan(
      checked ? subscriptionPlans?.yearly : subscriptionPlans?.quarterly
    );
  }, [checked]);

  const formatted = (amount: number) =>
    new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);

  const calculateSavings = () => {
    if (!subscriptionPlans?.quarterly || !subscriptionPlans?.yearly) return 0;

    const quarterlyTotalForYear = subscriptionPlans.quarterly.amount * 4; // 4 quarters in a year
    const yearlyPrice = subscriptionPlans.yearly.amount;

    const savings = quarterlyTotalForYear - yearlyPrice;
    return savings > 0 ? savings : 0;
  };

  const [buttonPrice, setButtonPrice] = useState<string | null>(null);
  return (
    <Layout>
      <>
        {defaultData ? (
          <Layout>
            <Header hideSideNav={true} />
            <div className="payment-page payment-history">
              <div className="container">
                <Row gutter={48} className="suscription">
                  <Col lg={13} sm={24} xs={30}>
                    <Card>
                      <div className="suscription__payment">
                        <div className="suscription__header">
                          <div className="payment-title">
                            <h3 className="title">Expert Guidance Access</h3>
                            <h2 className="price-tile">
                              {selectedPlan?.formatted_amount}<span>/{selectedPlan?.interval_name || ""}</span>
                            </h2>

                          </div>
                          <div className="checkbox-wrapper">
                            {subscriptionPlans?.quarterly && (
                              <p className="chck-title">{subscriptionPlans.quarterly.product_name}</p>
                            )}
                            <Switch
                              checked={checked}
                              onChange={onChange}
                              className="suscription-switch"
                            />
                            <div className="yearly-wrapper">
                              {subscriptionPlans?.yearly && (
                                <>
                                  <p className="chck-title">{subscriptionPlans.yearly.product_name}</p>
                                  <p className="chck-title yearly-title">
                                    (SAVE ${calculateSavings()})
                                  </p>
                                </>
                              )}
                            </div>
                          </div>
                          {/* 
                          <div className="suscription-offer">
                            <Button
                              className={`offer-btn ${checked ? "yearly-offer" : "quarterly-offer"
                                }`}
                              onClick={() =>
                                setButtonPrice(
                                  checked
                                    ? selectedPlan?.formatted_amount
                                    : selectedPlan?.formatted_amount
                                )
                              }
                            >
                              {checked
                                ? "Get One Year Access"
                                : "Get 3 Months Access"}
                            </Button>
                          </div> */}
                          <div className="offer-list">
                            <p className="offer-list__des">
                              {checked
                                ? `Total ${selectedPlan?.formatted_amount} / ${selectedPlan?.interval_name}. Subscription renews every year. Cancel anytime.`
                                : `Total ${selectedPlan?.formatted_amount} / ${selectedPlan?.interval_name}. Subscription renews every 3 months. Cancel anytime.`}
                            </p>
                          </div>
                        </div>
                        <h3 className="offer-list__title mb-1">Includes:</h3>
                        {list &&
                          list.map((item, i) => {
                            const title =
                              i === 0 && checked
                                ? "4x Human Expert Guidance"
                                : item.title;
                            const tooltip =
                              i === 0 && checked
                                ? "You’ll get routine checkup every 3 months"
                                : item.tooltips;
                            return (
                              <div key={i} className="item-list-wrapper">
                                <div className="item-list">
                                  <div>
                                    <img
                                      src={item.image}
                                      alt={item.title}
                                      height={70}
                                    />
                                  </div>
                                  <div>
                                    <h1>{title}</h1>
                                  </div>
                                </div>
                                <div className="item-list-tooltips">
                                  <Tooltip
                                    title={tooltip} // tooltip text from your data
                                    placement="top"
                                    overlayClassName="suscription-tooltip"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="30"
                                      height="30"
                                      viewBox="0 0 24 24"
                                      style={{ cursor: "pointer" }}
                                    >
                                      <path
                                        fill="#000000"
                                        d="M12.3 7.29c.2-.18.44-.29.7-.29c.27 0 .5.11.71.29c.19.21.29.45.29.71c0 .27-.1.5-.29.71c-.21.19-.44.29-.71.29c-.26 0-.5-.1-.7-.29c-.19-.21-.3-.44-.3-.71c0-.26.11-.5.3-.71m-2.5 4.68s2.17-1.72 2.96-1.79c.74-.06.59.79.52 1.23l-.01.06c-.14.53-.31 1.17-.48 1.78c-.38 1.39-.75 2.75-.66 3c.1.34.72-.09 1.17-.39c.06-.04.11-.08.16-.11c0 0 .08-.08.16.03c.02.03.04.06.06.08c.09.14.14.19.02.27l-.04.02c-.22.15-1.16.81-1.54 1.05c-.41.27-1.98 1.17-1.74-.58c.21-1.23.49-2.29.71-3.12c.41-1.5.59-2.18-.33-1.59c-.37.22-.59.36-.72.45c-.11.08-.12.08-.19-.05l-.03-.06l-.05-.08c-.07-.1-.07-.11.03-.2M22 12c0 5.5-4.5 10-10 10S2 17.5 2 12S6.5 2 12 2s10 4.5 10 10m-2 0c0-4.42-3.58-8-8-8s-8 3.58-8 8s3.58 8 8 8s8-3.58 8-8Z"
                                      />
                                    </svg>
                                  </Tooltip>
                                </div>
                              </div>
                            );
                          })}
                        <div>
                          {/* <div className="sub-total-holder">
                            <span className="sub-total">Subtotal</span>
                            <span className="sub-total-price">
                              ${data?.amount / 100} <del>${total}</del>
                            </span>
                          </div> */}
                          {/* <div className="sub-total-holder">
                            <span className="sub-total">Sales Tax</span>
                            <span className="sub-total-sales">$0</span>
                          </div> */}
                          {/* <div className="sub-total-holder-bg">
                          <span className="save">
                            Save Over 60%
                          </span>
                        </div> */}
                          {/* <div className="sub-total-holder">
                          <span className="total">Total</span>
                          <span className="total-price">
                            ${defaultData?.total_amount}
                          </span>
                        </div> */}
                        </div>
                      </div>
                      {checked && <MostPopular />}
                      <img
                        src={divider}
                        alt="divider"
                        style={{
                          width: "100%",
                          transform: "scaleY(1) scale(1.2)",
                          marginBlockStart: "1.5rem",
                        }}
                      />
                      <div className="peace-of-mind">
                        <div className="peace-of-mind__heading">
                          <img src={iconFull} alt="icon" />
                          <h3 className="title">Peace Of Mind</h3>
                        </div>
                        <div className="peace-of-mind__des">
                          <p>
                            If you are not satisfied with your skin care routine, our expert will revise it without extra cost. Just let us know within 14 days.
                          </p>
                        </div>
                      </div>
                    </Card>
                  </Col>
                  <Col lg={11} sm={24} xs={24} className={"position-relative"}>

                    <div className="payment-section">
                      <div className="payment-in">
                        <div className="payment-in__wrapper">
                          <span className="plantitle">Plan Name</span>
                          <p className="plandes">
                            {selectedPlan?.plan_name}
                          </p>
                        </div>
                        <div className="payment-in__wrapper">
                          <span className="plantitle">Amount</span>
                          <p className="plandes">
                            {selectedPlan?.formatted_amount} for {selectedPlan?.plan_intervalcount} {selectedPlan?.plan_interval}
                          </p>
                        </div>
                      </div>
                      {loadingPayment || loading ? (
                        <Spin size="large" className="loading-spinner" />
                      ) : (
                        <></>
                      )}
                      {isZeroAmount ? (
                        <Button
                          loading={loadingPaymentConfirmation}
                          className="proceed-btn btn-primary"
                          onClick={(e?: any) => {
                            paymentConfirmation(e);
                          }}
                        >
                          Proceed
                        </Button>
                      ) : (
                        <></>
                      )}
                      {clientSecret ? (

                        <Elements options={options} stripe={stripePromise}>

                          <PaymentComponent
                            surveyId={surveyId}
                            loadingProfile={loading}
                            loadingPayment={loadingPayment}
                            setLoadingPayment={setLoadingPayment}
                            paymentConfirmation={paymentConfirmation}
                            price={buttonPrice} //price update
                            setLoadingPaymentConfirmation={
                              setLoadingPaymentConfirmation
                            }
                            loadingPaymentConfirmation={
                              loadingPaymentConfirmation
                            }
                          // clientSecret={options?.clientSecret}
                          // email={email}
                          // setEmail={setEmail}
                          // name={name}
                          // setName={setName}
                          />
                        </Elements>
                      ) : (
                        <Spin size="large" className="loading-spinner" />
                      )}
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Layout>
        ) : (
          <div className="emtpy-payment">
            <Spin />
            <h1>Fetching payment details. Please wait...</h1>
          </div>
        )}
      </>
    </Layout>
  );
};
export default PaymentHistory;
